<div class="profile-dialog" fxLayout="column" fxLayoutGap="15px" [formGroup]="profileForm">
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">
    <div fxLayout="column" fxFlex="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="profileObject">
        <div fxFlex="100">
          <div fxLayout="row" fxLayoutGap="15px">
            <div>
              <div (click)="setAvatar()" class="user-avatar circular-image" *ngIf="profileObject.avatarLocation"
                   matRipple
                   [matRippleCentered]="false"
                   [matRippleDisabled]="false"
                   [matRippleUnbounded]="false"
                   [matRippleRadius]="10"
                   [matRippleColor]="'grey'" >
                <img class="avatar circular-image" src="/rest/sso/api/user/{{profileObject.userId}}/avatar?{{imgCnt}}" alt="Zdjęcie"/>
              </div>
              <div>
                <span fxFlex></span>
              </div>
              <input #avatarSelect type="file" style="display: none" [formControl]="avatarSelectControl"
                     accept=".jpg,.gif,.png,.jpeg"/>
            </div>
            <div>
              <h3>Dane użytkownika</h3>
            </div>
          </div>

          <ng-container>
            <div fxLayout="row" class="profile-username">
              <div fxFlex="100">
                <app-detail header="Nazwa" [value]="profileObject.username"></app-detail>
              </div>
            </div>
          </ng-container>

          <div fxLayout="row" fxLayoutGap="15px">
            <mat-form-field fxFlex="50">
              <mat-label>Imię</mat-label>
              <input matInput placeholder="Jan" formControlName="firstName" [required]="true">
              <mat-error *ngIf="profileForm.get('firstName').hasError('required')">To pole jest wymagane</mat-error>
            </mat-form-field>

            <mat-form-field fxFlex="50">
              <mat-label>Nazwisko</mat-label>
              <input matInput placeholder="Kowalski" formControlName="lastName" [required]="true">
              <mat-error *ngIf="profileForm.get('lastName').hasError('required')">To pole jest wymagane</mat-error>
            </mat-form-field>
          </div>

          <div fxLayout="row" fxLayoutGap="15px">
            <mat-form-field fxFlex="50">
              <mat-label>Numer telefonu</mat-label>
              <input matInput placeholder="+48500200300" formControlName="phoneNumber" [required]="true" prefix="+48" mask=" 000 000 000">
              <mat-error *ngIf="profileForm.get('phoneNumber').hasError('required')">To pole jest wymagane</mat-error>
              <mat-error *ngIf="profileForm.get('phoneNumber').hasError('invalidPhoneNumber')">Podaj prawidłowy numer telefonu</mat-error>
            </mat-form-field>

            <mat-form-field fxFlex="50">
              <mat-label>Email</mat-label>
              <input matInput placeholder="adres@test.pl" formControlName="email" [required]="true">
              <mat-error *ngIf="profileForm.get('email').hasError('required')">To pole jest wymagane</mat-error>
              <mat-error *ngIf="profileForm.get('email').hasError('invalidEmailAddress')">Podaj prawidłowy adres email</mat-error>
            </mat-form-field>
          </div>

          <div fxLayout="row" fxLayoutGap="15px">
            <mat-form-field fxFlex="100">
              <mat-label>Stanowisko</mat-label>
              <input matInput placeholder="Starszy specjalista" formControlName="position" [required]="false">
            </mat-form-field>
          </div>

          <div fxLayout="row" fxLayoutGap="15px" *ngIf="(userPermissions | async).mailing?.read">
                <h4>Mailing</h4>
          </div>

          <div fxLayout="row" fxLayoutGap="15px" *ngIf="(userPermissions | async).mailing?.read">
            <mat-form-field fxFlex="100">
              <mat-label>Email</mat-label>
              <input matInput placeholder="Email" formControlName="mailingEmail" [required]="false">
            </mat-form-field>
          </div>

          <div fxLayout="row" fxLayoutGap="15px" *ngIf="(userPermissions | async).mailing?.read">
            <mat-form-field fxFlex="100">
              <mat-label>Hasło</mat-label>
              <input matInput placeholder="Hasło" formControlName="mailingH" [required]="false">
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!profileForm.valid"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="setAvatar()" mat-stroked-button color="primary"><mat-icon>file_upload</mat-icon> <span> Zmień zdjęcie</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
